export const ROLE_SUPER_ADMIN = 'super_admin';
export const ROLE_FRANCHISEE = 'franchisee';
export const ROLE_RESTAURANT_ADMIN = 'restaurant_admin';
export const ROLE_STAFF = 'staff';

export const canManageMenu = (role, isSuperAdmin = false, isFranchisee = false) =>
  isSuperAdmin || isFranchisee || role === ROLE_RESTAURANT_ADMIN;

export const canManageStaff = (role, isSuperAdmin = false, isFranchisee = false) =>
  isSuperAdmin || isFranchisee || role === ROLE_RESTAURANT_ADMIN;

export const canUpdateAvailability = (role, isSuperAdmin = false, isFranchisee = false) =>
  isSuperAdmin || isFranchisee || role === ROLE_RESTAURANT_ADMIN || role === ROLE_STAFF;
